import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=22747dc2"
import script from "./UserCard.js?vue&type=script&lang=js&external"
export * from "./UserCard.js?vue&type=script&lang=js&external"
import style0 from "./UserCard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports